import React, { useEffect, useState } from 'react';
import { ai } from './TelemetryService';
import { useHistory } from 'react-router';

interface TelemetryProviderProps {
   children: JSX.Element;
}

const AppInsightsConnectionString =
   process.env.REACT_APP_INSIGHTS_CONNECTION_STRING;

const TelemetryProvider = (props: TelemetryProviderProps): JSX.Element => {
   const [initialized, setInitialized] = useState(false);
   //eslint-disable-next-line
   const [, setAppInsight]: any = useState();
   const history = useHistory();

   if (!AppInsightsConnectionString) {
      //eslint-disable-next-line
      console.warn(
         'Could not initialize Telemetry Service - connection string not found'
      );
   }

   useEffect((): void => {
      if (!initialized && AppInsightsConnectionString && history) {
         const appInsight = ai.initialize(AppInsightsConnectionString, history);
         setInitialized(true);
         setAppInsight(appInsight);
      }
   }, [initialized, history]);

   return <>{props.children}</>;
};

export default TelemetryProvider;
